import { DateUtils } from '../utils/date-utils';

export const estimatorConfig = {
    minConstructionYear: 0,
    minPurchaseYear: 1970,
    maxPurchaseYear: DateUtils.getCurrentYear(),
    minPurchasePrice: 50000,
    maxPurchasePrice: 2500000,
    minSurface: 25,
}